// react-native-confirmation-code-input relies on focus events being
// asynchronous, which is not the case in the DOM. Same props, web friendly.
import React from "react";
import { View, TextInput } from "react-native-web";

export default class ConfirmationCodeInput extends React.Component {
  static defaultProps = {
    codeLength: 5,
    size: 40,
    space: 8,
    autoFocus: true,
    ignoreCase: false,
    activeColor: "rgba(255, 255, 255, 1)",
    inactiveColor: "rgba(255, 255, 255, 0.2)",
    onFulfill: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      codeArr: new Array(props.codeLength).fill(""),
      currentIndex: 0,
    };
    this.inputs = [];
  }

  clear(silent) {
    this.setState(
      { codeArr: new Array(this.props.codeLength).fill(""), currentIndex: 0 },
      () => {
        if (!silent) {
          this.focus(0);
        }
      },
    );
  }

  focus(index) {
    if (this.inputs[index]) {
      this.inputs[index].focus();
    }
  }

  onFocus(index) {
    // always continue at the first empty box
    const firstEmpty = this.state.codeArr.findIndex(c => !c);
    const target = firstEmpty !== -1 && firstEmpty < index ? firstEmpty : index;
    if (target !== index) {
      return this.focus(target);
    }
    this.setState({ currentIndex: index });
  }

  onKeyPress(e, index) {
    if (e.nativeEvent.key !== "Backspace") {
      return;
    }
    const codeArr = this.state.codeArr.slice();
    const target = codeArr[index] ? index : Math.max(index - 1, 0);
    for (let i = target; i < codeArr.length; i += 1) {
      codeArr[i] = "";
    }
    this.setState({ codeArr, currentIndex: target }, () => this.focus(target));
  }

  // entry from an on screen keypad, the device keyboard stays closed
  press(character) {
    const index = this.state.codeArr.findIndex(c => !c);
    if (index !== -1) {
      this.onInput(String(character), index, true);
    }
  }

  backspace() {
    const codeArr = this.state.codeArr.slice();
    let index = codeArr.length - 1;
    while (index > 0 && !codeArr[index]) {
      index -= 1;
    }
    codeArr[index] = "";
    this.setState({ codeArr, currentIndex: index });
  }

  onInput(text, index, silent) {
    const { codeLength, compareWithCode, ignoreCase, onFulfill } = this.props;
    const characters = text.replace(/\s/g, "").split("");
    if (!characters.length) {
      return;
    }
    const codeArr = this.state.codeArr.slice();
    let position = index;
    characters.forEach(character => {
      if (position < codeLength) {
        codeArr[position] = character;
        position += 1;
      }
    });

    if (position >= codeLength) {
      const code = codeArr.join("");
      this.setState({ codeArr, currentIndex: codeLength - 1 }, () => {
        if (this.inputs[codeLength - 1]) {
          this.inputs[codeLength - 1].blur();
        }
        if (compareWithCode) {
          const matches = ignoreCase
            ? code.toLowerCase() === String(compareWithCode).toLowerCase()
            : code === String(compareWithCode);
          onFulfill(matches, code);
          if (!matches) {
            this.clear(silent);
          }
        } else {
          onFulfill(code);
        }
      });
    } else {
      this.setState({ codeArr, currentIndex: position }, () => {
        if (!silent) {
          this.focus(position);
        }
      });
    }
  }

  render() {
    const {
      codeLength,
      size,
      space,
      activeColor,
      inactiveColor,
      codeInputStyle,
      containerStyle,
      secureTextEntry,
      autoFocus,
    } = this.props;

    const inputs = [];
    for (let i = 0; i < codeLength; i += 1) {
      const active = this.state.currentIndex === i;
      inputs.push(
        <TextInput
          key={i}
          ref={ref => {
            this.inputs[i] = ref;
          }}
          style={[
            {
              width: size,
              height: size,
              marginHorizontal: space / 2,
              textAlign: "center",
              padding: 0,
              borderWidth: 1,
              borderRadius: 12,
              borderColor: active ? activeColor : inactiveColor,
              color: activeColor,
              fontSize: size * 0.5,
              backgroundColor: "transparent",
            },
            codeInputStyle,
          ]}
          autoFocus={autoFocus && i === 0}
          secureTextEntry={secureTextEntry}
          keyboardType="numeric"
          autoComplete="off"
          value={this.state.codeArr[i] ? String(this.state.codeArr[i]) : ""}
          onFocus={() => this.onFocus(i)}
          onChangeText={text => this.onInput(text, i)}
          onKeyPress={e => this.onKeyPress(e, i)}
        />,
      );
    }

    return (
      <View
        style={[
          {
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 20,
            height: size,
          },
          containerStyle,
        ]}
      >
        {inputs}
      </View>
    );
  }
}
